import { getInputProps } from '@conform-to/react'
import { Field } from './forms'

type DimensionInputsProps = {
	width: number
	height: number
	onWidthChange: (value: number) => void
	onHeightChange: (value: number) => void
	fields: {
		width: any // Replace with proper type from your form library
		height: any // Replace with proper type from your form library
	}
}

export function DimensionInputs({
	width,
	height,
	onWidthChange,
	onHeightChange,
	fields,
}: DimensionInputsProps) {
	return (
		<div className="flex flex-row items-center justify-start gap-3">
			<div className="flex items-end justify-start space-x-4">
				<Field
					labelProps={{ htmlFor: fields.width.id, children: 'Width' }}
					inputProps={{
						...Object.fromEntries(
							Object.entries(getInputProps(fields.width, { type: 'text' })).filter(
								([key]) => key !== 'defaultValue',
							),
						),
						value: width,
						onChange: e => {
							const newValue = e.target.value
							if (/^\d*$/.test(newValue)) onWidthChange(parseInt(newValue) || 0)
						},
						className: 'w-20 text-right rounded-md border-gray-300 shadow-sm focus:ring-opacity-50',
					}}
					disableErrorField={true}
					errors={fields.width.errors}
				/>
				<span className="mb-2 text-2xl text-gray-500">×</span>
				<Field
					labelProps={{ htmlFor: fields.height.id, children: 'Height' }}
					inputProps={{
						...Object.fromEntries(
							Object.entries(getInputProps(fields.height, { type: 'text' })).filter(
								([key]) => key !== 'defaultValue',
							),
						),
						value: height,
						onChange: e => {
							const newValue = e.target.value
							if (/^\d*$/.test(newValue)) onHeightChange(parseInt(newValue) || 0)
						},
						className: 'w-20 text-right rounded-md border-gray-300 shadow-sm focus:ring-opacity-50',
					}}
					disableErrorField
					errors={fields.height.errors}
				/>
			</div>
			<span className="mt-6 text-gray-500">pixels</span>
		</div>
	)
}
